// src/hooks/useTranslation.js

import { useState, useEffect, useCallback } from 'react';

// --- NEW Translation Hook ---
const TRANSLATION_STORAGE_KEY = 'kikikata_translation_visibility';
const TRANSLATION_CHANGE_EVENT = 'kikikata_translation_change';

const getStoredTranslationValue = () => {
  try {
    const item = window.localStorage.getItem(TRANSLATION_STORAGE_KEY);
    // Default to true (visible) if no setting is stored yet
    return item ? JSON.parse(item) : true;
  } catch (error) {
    console.error('Error reading translation visibility from localStorage', error);
    return true;
  }
};

export const useTranslation = () => {
  const [showTranslation, setShowTranslation] = useState(getStoredTranslationValue);

  useEffect(() => {
    const handleStorageChange = () => {
      setShowTranslation(getStoredTranslationValue());
    };

    window.addEventListener(TRANSLATION_CHANGE_EVENT, handleStorageChange);
    return () => {
      window.removeEventListener(TRANSLATION_CHANGE_EVENT, handleStorageChange);
    };
  }, []);

  const setTranslationVisibility = useCallback(
    (value) => {
      const newValue = typeof value === 'function' ? value(getStoredTranslationValue()) : value;
      try {
        window.localStorage.setItem(TRANSLATION_STORAGE_KEY, JSON.stringify(newValue));
        // Dispatch a custom event to notify other components using this hook on the same page
        window.dispatchEvent(new Event(TRANSLATION_CHANGE_EVENT));
      } catch (error) {
        console.error('Error setting translation visibility in localStorage', error);
      }
    },
    []
  );

  return [showTranslation, setTranslationVisibility];
};
